import { VOCategory } from "../../model/DataStructure.js";
import { GalleryList } from "../GalleryList.js";
import { MediaItem } from "../MediaItem.js";
import { AbstractContentView } from "./AbstractContentView.js";

export class GalleryContentView extends AbstractContentView {

    private _text: HTMLDivElement;
    private _title: HTMLDivElement;
    private _subtitle: HTMLDivElement;
    private _description: HTMLDivElement;
    private _listContainer: HTMLDivElement;
    private _galleryList: GalleryList = null;
    private _mediaItem: MediaItem;
    private _category: VOCategory;

    constructor(private _kind: "gallery" | "media_and_text") {
        super();

        this.element.classList.add("gallery-content-view");
        this.element.innerHTML = `
        <div class="gallery-view-left">
            <div class="gallery-view-image"></div>
            <div class="gallery-view-text scrollbar vert">
                <div class="gallery-view-title"></div>
                <div class="gallery-view-subtitle"></div>
                <div class="gallery-view-description"></div>
            </div>
        </div>
        <div class="gallery-list-container"></div>
        `;

        this._text = this.element.querySelector(".gallery-view-text");
        this._title = this.element.querySelector(".gallery-view-title");
        this._subtitle = this.element.querySelector(".gallery-view-subtitle");
        this._description = this.element.querySelector(".gallery-view-description");
        this._listContainer = this.element.querySelector(".gallery-list-container");

        this._mediaItem = new MediaItem({
            element: this.element.querySelector(".gallery-view-image")
        })

        this.showArrows = {
            left: "none",
            right: "none",
            index: 0,
            total: 0
        };

        if (this._kind == "gallery") {
            this._galleryList = new GalleryList();
            this._listContainer.appendChild(this._galleryList.element);
            this._galleryList.onRequestGallery.add(this.onRequestGallery.dispatch, this.onRequestGallery);
        } else {
            this.element.classList.add("no-gallery-list");
            this._listContainer.classList.add("hidden");
        }

        this.onCloseGallery.add((galleryList, galleryIndex, mediaIndex) => {
            if (this._galleryList)
                this._galleryList.show(galleryIndex, mediaIndex);
        });
    }

    public open(): void {

        if (this._category.image) {
            this._mediaItem.load(this._category.image);
        }

        this._text.scrollTop = 0;
        if (this._galleryList)
            this._galleryList.element.scrollTop = 0;
    }

    public async create(category: VOCategory): Promise<boolean> {
        if (!category)
            return false;
        this._category = category;

        this.onBlurChange.add((blurred) => {
            if (blurred) {
                this._mediaItem.stop();
            }
        });

        this.onActiveChange.add((active) => {
            if (!active) {
                this._mediaItem.stop();
            }
        });

        this._title.innerHTML = category.title;
        this._subtitle.classList.toggle("hidden", !Boolean(category.subtitle));
        if (category.subtitle)
            this._subtitle.innerHTML = category.subtitle;
        this._description.innerHTML = category.description || "";

        if (this._galleryList)
            this._galleryList.create(category.galleries);

        return true;
    }

    public reset(): void {
        this._mediaItem.clear();
        if (this._galleryList)
            this._galleryList.reset();
    }

    public handleClickClose(): boolean {
        return true;
    }
}